package app.nestbridge.feature.children.api

import app.nestbridge.app.di.ClientApiConfig
import app.nestbridge.feature.children.api.model.ChildDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class RemoteChildApiClient(
    private val httpClient: HttpClient,
    private val config: ClientApiConfig,
) : ChildApiClient {

    private val baseUrl get() = "${config.childServiceUrl}/children"

    override suspend fun fetch(id: String): ChildDto? {
        val response: HttpResponse = httpClient.get("$baseUrl/$id")
        return when (response.status) {
            HttpStatusCode.OK -> response.body()
            HttpStatusCode.NotFound -> null
            else -> error("Unexpected response fetching child '$id': ${response.status}")
        }
    }

    override suspend fun fetchAll(): List<ChildDto> =
        httpClient.get(baseUrl).body()

    override suspend fun save(child: ChildDto): ChildDto {
        val response = if (child.id.isBlank()) {
            httpClient.post(baseUrl) {
                contentType(ContentType.Application.Json)
                setBody(child)
            }
        } else {
            httpClient.put("$baseUrl/${child.id}") {
                contentType(ContentType.Application.Json)
                setBody(child)
            }
        }
        return response.body()
    }
}
